import React from "react";
import { Navigate } from "react-router-dom";

const AccountPayableListComponent = React.lazy(
  () =>
    import("../../../../../components/account-payable/components/list/page"),
);
const AccountPayableAddComponent = React.lazy(
  () =>
    import("../../../../../components/account-payable/components/add/page"),
);

export const accountPayableRoutes = [
  {
    path: "add",
    element: <AccountPayableAddComponent />,
  },
  {
    path: "list",
    element: <AccountPayableListComponent />,
  },
  {
    path: "",
    element: <Navigate replace to="/finanzas/account-payable/list" />,
  },
];
